<template>
  <NaviSelectCascading :config="config" />
</template>

<script>
import NaviSelectCascading from "../../components/NaviSelectCascading/NaviSelectCascading.vue";

export default {
  name: "app",
  components: {
    NaviSelectCascading
  },
  data() {
    return {
      config: JSON.parse(this.$options._parentVnode.data.props.config)
    };
  }
};
</script>
